import React from "react";

const SurveyHeader = ({ survey, theme }) => {
    if (!survey?.title && !survey?.description) return null;

    return (
        <>
            {survey.title && (
                <div className={`text-${survey.headerPosition || "left"}`}>
                    {React.createElement(
                        survey.headingType || "h2",
                        {
                            className: "mb-1",
                            style: { color: theme?.colors?.primary || "#000" },
                        },
                        survey.title
                    )}
                </div>
            )}

            {survey.description && (
                <p
                    className={`mb-4 text-${survey.descriptionPosition || "left"}`}
                    style={{ color: survey.descriptionColor || "#6c757d" }}
                >
                    {survey.description}
                </p>
            )}
        </>
    );
};

export default SurveyHeader;
